import React, { useState } from "react";
import { Box, ThemeProvider } from "@mui/material";
import Home from "./home/home";
import Footer from "./footer/footer";
import theme from "./theme";
import Cookies from "js-cookie";
import NotificationModal from "./notificationModal/notificationModal";
import SurveyNotification from "./notifications/surveyNotification/surveyNotification";

const App: React.FC = () => {
  const [bylaw, setBylaw] = useState<string>(Cookies.get("bylaw") ?? "New");

  if (window.matchMedia("(display-mode: standalone)").matches) {
    // PWA is running in standalone mode
    console.log("Running as standalone");
  } else {
    // PWA is running in browser mode
    console.log("Running in browser");
  }
  return (
    <ThemeProvider theme={theme}>
      <>
        <SurveyNotification />
        <Box
          sx={{
            fontFamily: "Barlow",
            display: "flex",
            flexDirection: "column",
            minHeight: window.matchMedia("(display-mode: standalone)").matches
              ? "88vh"
              : "80vh",
          }}
        >
          <Home bylaw={bylaw} />
        </Box>
      </>
      <Footer />
    </ThemeProvider>
  );
};

export default App;
